import i18n from "@/plugins/vue-i18n";
export default {
  namespaced: true,
  state: {
    currency: i18n.t(`currency.shortDesignation`),
    currencySymbol: i18n.t(`currency.symbol`),
  },
};
